import {gql} from '@apollo/client';

export const MAX_QUERY_COUNT = 400;
export const sitemapLink = '/all-cities-zoning-map';
export const sitemapTitle = 'Zoning Markets';

export const sitemapDataQuery = gql`
  {
    placesSettings
  }
`;

export const ALLOWED_PLACE_TYPES = [
  'balance',
  'city',
  'municipality',
  'town',
  'zona-urbana',
  'comunidad',
  'village',
  'undefined',
  'borough',
  'census-designated-place',
  'community-development-district',
  'county-subdivision',
  'neighborhood',
];
